<phx-input-group [phxSuffix]="suffix">
  <input
    phx-input
    [type]="isTextHidden ? 'password' : 'text'"
    [disabled]="phxDisabled"
    [ngModel]="phxPasswordValue"
    (input)="onPasswordChange($event)"
    (blur)="onBlur()"
  />
</phx-input-group>

<ng-template #suffix>
  <button
    phx-icon-button
    [disabled]="phxDisabled"
    [phxIcon]="isTextHidden ? eyeIcon : disabledEyeIcon"
    [phxIconButtonSize]="'small'"
    (click)="onEyeIconClick()">
  </button>
</ng-template>
